import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sidebar-panel is-generic" }
const _hoisted_2 = {
  class: "inner",
  "data-simplebar": ""
}
const _hoisted_3 = { class: "has-children" }
const _hoisted_4 = { class: "has-children" }
const _hoisted_5 = { class: "has-children" }
const _hoisted_6 = { class: "has-children" }
const _hoisted_7 = {
  key: 0,
  class: "has-children"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { key: 5 }
const _hoisted_14 = { key: 6 }
const _hoisted_15 = { key: 7 }

import {ref} from 'vue'
import store from '../../store'


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardsSubsidebar',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const openSubsidebarLinks = ref('')
const emit = __emit

const user = store.state.user;
const isStaff = store.state.user.is_staff;


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_has_nested_router_link = _resolveDirective("has-nested-router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "collapse-wrap" }, [
            _createElementVNode("a", { class: "parent-link" }, [
              _createTextVNode(" Home "),
              _createElementVNode("i", {
                "aria-hidden": "false",
                class: "iconify",
                "data-icon": "feather:chevron-right"
              })
            ])
          ], -1)),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: { name: 'Index' },
                class: "is-submenu"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("i", {
                    "aria-hidden": "true",
                    class: "lnil lnil-house-alt"
                  }, null, -1),
                  _createElementVNode("span", null, "Home", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])), [
          [_directive_has_nested_router_link]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "collapse-wrap" }, [
            _createElementVNode("a", { class: "parent-link" }, [
              _createTextVNode(" Builder tools "),
              _createElementVNode("i", {
                "aria-hidden": "true",
                class: "iconify",
                "data-icon": "feather:chevron-right"
              })
            ])
          ], -1)),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: { name: 'strats-list' },
                class: "is-submenu"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("i", {
                    "aria-hidden": "true",
                    class: "lnil lnil-strategy"
                  }, null, -1),
                  _createElementVNode("span", null, "Strategies", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: { name: 'custom-page-builder' },
                class: "is-submenu"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", {
                    "aria-hidden": "true",
                    class: "lnil lnil-slideshow"
                  }, null, -1),
                  _createElementVNode("span", null, "Custom Page Builder", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])), [
          [_directive_has_nested_router_link]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "collapse-wrap" }, [
            _createElementVNode("a", { class: "parent-link" }, [
              _createTextVNode(" My Orders "),
              _createElementVNode("i", {
                "aria-hidden": "true",
                class: "iconify",
                "data-icon": "feather:chevron-right"
              })
            ])
          ], -1)),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: { name: 'customer-orders-list' },
                class: "is-submenu"
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("i", {
                    "aria-hidden": "true",
                    class: "lnil lnil-strategy"
                  }, null, -1),
                  _createElementVNode("span", null, "Orders", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])), [
          [_directive_has_nested_router_link]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "collapse-wrap" }, [
            _createElementVNode("a", { class: "parent-link" }, [
              _createTextVNode(" Live quotes "),
              _createElementVNode("i", {
                "aria-hidden": "true",
                class: "iconify",
                "data-icon": "feather:chevron-right"
              })
            ])
          ], -1)),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: { name: 'stream-custom' },
                class: "is-submenu"
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("i", {
                    "aria-hidden": "true",
                    class: "lnil lnil-thumbnail"
                  }, null, -1),
                  _createElementVNode("span", null, "Custom Page", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: { name: 'stream-alerts' },
                class: "is-submenu"
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("i", {
                    "aria-hidden": "true",
                    class: "lnil lnil-notification"
                  }, null, -1),
                  _createElementVNode("span", null, "Alerts Page", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: { name: 'yield' },
                class: "is-submenu"
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("i", {
                    "aria-hidden": "true",
                    class: "lnil lnil-scaling"
                  }, null, -1),
                  _createElementVNode("span", null, "Yield spreads", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: { name: 'stream-futures' },
                class: "is-submenu"
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("i", {
                    "aria-hidden": "true",
                    class: "lnil lnil-house-plan"
                  }, null, -1),
                  _createElementVNode("span", null, "House Indices", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])), [
          [_directive_has_nested_router_link]
        ]),
        (_unref(isStaff))
          ? _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_7, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "collapse-wrap" }, [
                _createElementVNode("a", { class: "parent-link" }, [
                  _createTextVNode(" Staff area "),
                  _createElementVNode("i", {
                    "aria-hidden": "true",
                    class: "iconify",
                    "data-icon": "feather:chevron-right"
                  })
                ])
              ], -1)),
              _createElementVNode("ul", null, [
                (_unref(isStaff))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'drift' },
                        class: "is-submenu"
                      }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("i", {
                            "aria-hidden": "true",
                            class: "lnil lnil-analytics-alt-1"
                          }, null, -1),
                          _createElementVNode("span", null, "Drift", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isStaff))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'yield-check' },
                        class: "is-submenu"
                      }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createElementVNode("i", {
                            "aria-hidden": "true",
                            class: "lnil lnil-target-alt-1"
                          }, null, -1),
                          _createElementVNode("span", null, "Yield check", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isStaff))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'yield-check-new' },
                        class: "is-submenu"
                      }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createElementVNode("i", {
                            "aria-hidden": "true",
                            class: "lnil lnil-target"
                          }, null, -1),
                          _createElementVNode("span", null, "Yield check new", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isStaff))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'orders-list' },
                        class: "is-submenu"
                      }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createElementVNode("i", {
                            "aria-hidden": "true",
                            class: "lnil lnil-tablet-alt"
                          }, null, -1),
                          _createElementVNode("span", null, "Orders list", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isStaff))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'endofdayrepo' },
                        class: "is-submenu"
                      }, {
                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                          _createElementVNode("i", {
                            "aria-hidden": "true",
                            class: "lnil lnil-sales-report"
                          }, null, -1),
                          _createElementVNode("span", null, "End of day repo", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isStaff))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'repo-history' },
                        class: "is-submenu"
                      }, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createElementVNode("i", {
                            "aria-hidden": "true",
                            class: "lnil lnil-layers"
                          }, null, -1),
                          _createElementVNode("span", null, "Repo history", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isStaff))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'group-page-builder-users' },
                        class: "is-submenu"
                      }, {
                        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                          _createElementVNode("i", {
                            "aria-hidden": "true",
                            class: "lnil lnil-mask"
                          }, null, -1),
                          _createElementVNode("span", null, "Groups Manager", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isStaff))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'cix-parser' },
                        class: "is-submenu"
                      }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createElementVNode("i", {
                            "aria-hidden": "true",
                            class: "lnil lnil-code"
                          }, null, -1),
                          _createElementVNode("span", null, "CIX", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])), [
              [_directive_has_nested_router_link]
            ])
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})